import { Icon } from '../../../../imagesAndIcons/Icon';
import { ItemVariant } from './types';
import { Text } from '../../../../typography/Text';
import { TextButton } from '../../../../actions/TextButton';
export var getTextButtonVariantFromItemVariant = function getTextButtonVariantFromItemVariant(variant) {
  if (!variant) {
    return TextButton.Variant.Dark;
  }

  switch (variant) {
    case ItemVariant.Primary:
      return TextButton.Variant.Primary;

    case ItemVariant.Dark:
    default:
      return TextButton.Variant.Dark;
  }
};
export var getStrokeColorFromItemVariant = function getStrokeColorFromItemVariant(variant) {
  if (!variant) {
    return Icon.Color.System;
  }

  switch (variant) {
    case ItemVariant.Primary:
      return Icon.Color.System;

    case ItemVariant.Dark:
    default:
      return Icon.Color.Dark;
  }
};
export var getFillColorFromItemVariant = function getFillColorFromItemVariant(variant) {
  if (!variant) {
    return Icon.Color.SystemLight;
  }

  switch (variant) {
    case ItemVariant.Primary:
      return Icon.Color.SystemLight;

    case ItemVariant.Dark:
    default:
      return Icon.Color.Gray5;
  }
};
export var getTextColorFromItemVariant = function getTextColorFromItemVariant(variant) {
  if (!variant) {
    return Text.Color.Dark;
  }

  switch (variant) {
    case ItemVariant.Primary:
      return Text.Color.System;

    case ItemVariant.Dark:
    default:
      return Text.Color.Dark;
  }
};